<template>
  <div class="greet bg_fff">
    <div class="greetContentL">
      <router-link class="routerLink" tag="a" to="/talent/greet">打招呼语</router-link>
      <router-link class="routerLink" tag="a" to="/talent/words">常用语</router-link>
    </div>
    <div class="greetContentR">
      <div class="pageTitle f_14 color_40">打招呼语设置</div>
      <div class="greetList">
        <div class="item flex-c cursor_p" v-for="(item,index) in greetList" :key="String(index)" @click="toggleGreet(index)">
          <div class="iconfont icondui color_blue" v-if="currentIndex===index"></div>
          <div class="icon" v-else></div>
          <div class="text flex1 f_14 color_60">{{item}}</div>
        </div>
      </div>
      <div class="maxlength pr">
        <el-input class="restInput color_60 f_14"
                  type="textarea" placeholder="请输入打招呼文案" v-model="greetContent" :autosize="{ minRows: 2, maxRows: 2}" :maxlength="100" resize="none" >
        </el-input>
        <div class="pa f_14 color_9c">{{greetContent.length}}/100</div>
      </div>
      <div class="templateButtons">
        <div class="confirmButton text_center bg_cf color_fff f_14 cursor_p" v-if="greetContentState">保存</div>
        <div class="confirmButton text_center color_fff f_14 cursor_p" v-else @click="saveGreet()">保存</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
// 所有接口
import actions from '@/actions/index'
//混入优化
import {mixinsUtils} from '@/mixins/search/utils';

import {checkUserState, get_tUser , toLogin} from '@/utils/utils';


export default {
  name: 'greet',
  data(){
    return {
      greetList:[],
      currentIndex:0,
      greetContent:'',
    }
  },
  computed:{
    ...mapState('block',['userInfoState']),
    greetContentState(){
      let { greetList, currentIndex, greetContent } = this._data;
      greetContent = greetContent.trim();
      return greetList[currentIndex] ? greetList[currentIndex] === greetContent || !greetContent : false;
    },
	  userToken () {
		  let { h_t } = get_tUser()
		  return h_t
	  }
  },
  mixins:[mixinsUtils],
  async created(){
    this.userJWT = await get_tUser();
    if(this.userJWT.h_t){
      //更新是否完善信息(状态库)
      let userInfo = await actions.hr_accounts.getUserinfo();
      this.toggleUserInfoState(userInfo)
    }else{
      this.toggleUserInfoState(false)
    }
    //获取列表
    this.getList();
  },
  methods:{
    ...mapMutations('block',['toggleUserInfoState']),
    getList(){
      if(this.isLoading){
        return false;
      }
      this.isLoading = true;
      actions.im.getGreetings({ user_token: this.userToken }).then(res => {
      	this.isLoading = false
      	if (res.code === 1000) {
      		let { b_content, b_current_index } = res.data
          this.greetList = b_content
          this.greetContent = b_content[b_current_index]
          this.currentIndex = b_current_index
        } else {
		      this.$message({
			      message: res.message,
			      type: 'error'
		      });
	      }
      })
      // actions.hr_accounts.getGreetings({}).then(res=>{
      //   this.isLoading = false;
      //   if(res.code=== 1000){
      //     let { greetings } = res.data;
      //     this.greetList = greetings;
      //     this.greetContent = greetings[0].content;
      //   }else{
      //     this.$message({
      //       message: res.message,
      //       type: 'error'
      //     });
      //   }
      // })
    },
    toggleGreet(index){
      //更新当前选中状态
      if(this.currentIndex !== index){
        this.updateGreetIndex(index);
      }
      this.currentIndex = index;
      this.greetContent = this.greetList[index];
      
    },
    saveGreet(){
      let greetContent = this.greetContent.trim();
      let greetList = JSON.parse(JSON.stringify(this.greetList))
      greetList[this.currentIndex] = greetContent
      let item = this.greetList[this.currentIndex];
      let payload = {
      	current_index: this.currentIndex,
        content: greetList,
        user_token: this.userToken,
        identity: 'b',
        status: true, //是否开启打招呼语
      }
      actions.im.editGreetings(payload).then(res => {
      	if (res.code === 1000) {
      		this.greetList = greetList
      		// this.greetList[this.currentIndex] = greetContent
		      this.$message({
			      message: '保存成功',
			      type: 'success'
		      });
        } else {
		      this.$message({
			      message: res.message,
			      type: 'error'
		      });
        }
      })
      // actions.hr_accounts.putGreetings(item.order,{content:greetContent}).then(res=>{
      //   if(res.code === 1000){
      //     this.greetList[this.currentIndex] = greetContent;
      //     this.$message({
      //       message: '保存成功',
      //       type: 'success'
      //     });
      //   }else{
      //     this.$message({
      //       message: res.message,
      //       type: 'error'
      //     });
      //   }
      // })


    },
    updateGreetIndex(index){
      let payload = {
      	current_index: index,
        content: this.greetList,
        user_token: this.userToken,
        identity: 'b',
        status: true, //是否开启打招呼语
      }
      actions.im.editGreetings(payload).then(res => {
      	if (res.code === 1000) {
      		
		      this.$message({
			      message: '下次打招呼时生效',
			      type: 'success'
		      });
        } else {
		      this.$message({
			      message: res.message,
			      type: 'error'
		      });
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
@import './Index.scss';

</style>
